import * as React from 'react';
import './TicketHolder.less'
import { EventHelper, DateHelper } from '@/common/Utils';
import FilterHelper from '@/common/Utils/FilterHelper';
import { InvoiceSimpleInfo, ProjectType } from '../statement';
import SmartMoneyService from '@/AppStore/SmartMoney/SmartMoneyService';
import { DingTalk } from '@/common/DingTalk';
import { Card } from 'antd-mobile';
import YdyListView from '@/components/YdyListView';

interface TicketHolderStateTypes {
  hasMore: boolean
  isLoading: boolean
  data: InvoiceSimpleInfo[]
  currentType: ProjectType,
  organizationId: string,
  projectId: string
}

interface TicketHolderPropTypes {
  height: number
  type: string
}

/**
 * 票夹列表
 */
export class TicketHolderList extends React.Component<TicketHolderPropTypes, TicketHolderStateTypes> {
  constructor(props: TicketHolderPropTypes) {
    super(props);
    let {projectId, organizationId, projectType} = FilterHelper.getLocationSearch()
    this.state = {
      currentType: parseInt(projectType),
      projectId: projectId || '',
      organizationId: organizationId || '',
      hasMore: false,
      isLoading: true,
      data: [],
    };
  }

  @EventHelper.exec()
  componentDidMount () {
    this.initList()
  }

  @EventHelper.exec()
  async ListRowClick (rowData: InvoiceSimpleInfo) {
    const {type} = this.props
    if (type === 'all') {
      DingTalk.open('SubmitInvoice', { id: rowData.id, projectType: rowData.type })
    } else {
      DingTalk.push('SubmitInvoice', { id: rowData.id, projectType: this.state.currentType })
    }
  }

  @EventHelper.execLock()
  async initList (pageIndex: number = 0, searchValue = '') {
    const {type} = this.props
    let { data, projectId, organizationId, currentType } = this.state;
    let result = await SmartMoneyService.getTicketHolderList(type, currentType, pageIndex, {projectId, organizationId}, searchValue)
    window.baseConfig.development && console.log(result);
    
    let hasMore = true;
    if (pageIndex === 0) {
      data = []
      hasMore = true
    }
    if (result.data.length === 0) {
      hasMore = false
      // return;
    }
    data = data.concat(result.data);
    this.setState({
      data,
      hasMore,
      isLoading: false,
    });
    return {
      pageIndex: pageIndex
    }
  }

  render () {
    const { hasMore, data, isLoading } = this.state;
    const { height, children } = this.props;
    const listRow = (rowData: InvoiceSimpleInfo, sectionID, rowID, highlightRow) => {
      return (
        <Card className="TicketHolderCard" key={rowData.id} onClick={this.ListRowClick.bind(this, rowData)}>
          <Card.Header
            title={rowData.showName}
          />
          <Card.Body>
            <div>开票日期：{DateHelper.format(rowData.invoiceDate)}</div>
            <div>价税合计：{FilterHelper.currency(rowData.totalTaxSum)}</div>
          </Card.Body>
          <Card.Footer content={rowData.projectName ? '所属项目：' + rowData.projectName : '所属公司：' + rowData.organizationName} />
        </Card>
      );
    }
    return (
      <YdyListView className="TicketHolderList" ListRow={listRow} hasMore={hasMore} isLoading={isLoading} height={height} data={data}
        initList={this.initList.bind(this)} initialListSize={16} placeholder="搜索发票" 
      >
      {children}
    </YdyListView>
    );
  }
}


// WEBPACK FOOTER //
// ./src/AppStore/SmartMoney/components/TicketHolder.tsx